import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    height:170,
  },
  card: {
    width: '80%',
    margin:"0 auto",
    height: '100%',
    borderRadius: 3,
    padding: 8,
    display: 'flex',
    boxShadow: '6px 8px 6px 5px rgb(0 0 0 / 18%)',
    flexDirection:'column',
    justifyContent:'center',
    transition: 'background 0.3s ease',
    background:
    "linear-gradient(38deg, rgba(10,110,112,1) 0%, rgba(22,198,227,0.8436624649859944) 65%)",
    '&:hover': {
      background:
      "linear-gradient(38deg, rgba(203,93,9,1) 0%, rgba(242,142,10,0.8436624649859944) 65%) !important",
        },
  },
  nameLabel: {
    '& .MuiTypography-root': {
      paddingBlockEnd: 8,
      fontWeight: 800,
      color: '#fff',
      fontSize: 15,
      textTransform: 'uppercase',
    },
  },
  autocomplete_control:{
  padding : "25px 0px"
  },  
  count: {
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    '& .MuiTypography-root': {
      fontWeight: 500,
      color: '#fff',
    },
    '& .MuiSvgIcon-root':{
      fontSize: 65,
      color: '#f0f8ffbf',
    }
  },
}))

export default useStyles
